import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Breadcrumbs, Link } from '@mui/material';

const CategoriesBreadCrumbs = (props) => {

	const { categories } = props;
	const { t } = useTranslation();

	return(
		<Breadcrumbs 
			aria-label="breadcrumb"
			separator="|"
		>
			<Link 
				component={NavLink}
			  	underline="hover" 
			  	color="primary" 
			  	to="/"
			>
				<b>Home</b>
			</Link>
			<Link 
				component={NavLink}
			  	underline="hover" 
			  	color="primary" 
			  	to="/ricette"
			>
				<b>{t("navigationBar_recipes")}</b>
			</Link>
			{
				categories.map((category) => (
					<Link 
						key={category.id}
						component={NavLink}
					  	underline="hover" 
					  	color="primary" 
					  	to={"/categorie/" + category.slug}
					>
						<b>{category.name}</b>
					</Link>
				))
			}
		</Breadcrumbs>	
	);
}

export default CategoriesBreadCrumbs;